import { Component } from '@angular/core'
import { FormState } from 'ngrx-forms'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { selectProfileState } from '../../user-profile.state'

@Component({
  selector: 'cover-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  formState$: Observable<FormState<string>>

  constructor(private readonly store: Store) {
    this.formState$ = this.store.select(selectProfileState.changeEmailPasswordPromptControl)
  }
}
